// 9fbef606107a605d69c0edbcd8029e5d
import constants from '../OrdersTile.constants';

export const getOrderListByShipment = (payload) => ({
  type: constants.GET_ORDERS_LIST_BY_SHIPMENT,
  payload,
});

export const setOrderListByShipment = (payload) => ({
  type: constants.SET_ORDERS_LIST_BY_SHIPMENT,
  payload,
});

export const showLoader = () => {
  return {
    type: constants.SHOW_LOADER,
  };
};

export const hideLoader = () => {
  return {
    type: constants.HIDE_LOADER,
  };
};

export const clearOrderListByShipment = () => {
  return {
    type: constants.CLEAR_ORDERS_LIST_BY_SHIPMENT,
  };
};
